import { jsPDF } from 'jspdf'

const PAGE_WIDTH_MM = 210
const PAGE_HEIGHT_MM = 297
const TEMPLATE_WIDTH = 1102
const TEMPLATE_HEIGHT = 1559
const EXPORT_SCALE = 2

export async function downloadReservationPdf(templatePage: HTMLElement, bookingId: string): Promise<void> {
  const baseImage = templatePage.querySelector<HTMLImageElement>('.base')
  if (!baseImage) throw new Error('The reservation template background could not be found.')

  if (!baseImage.complete) {
    await new Promise<void>((resolve, reject) => {
      baseImage.addEventListener('load', () => resolve(), { once: true })
      baseImage.addEventListener('error', () => reject(new Error('The reservation template background could not be loaded.')), { once: true })
    })
  }
  if (baseImage.naturalWidth === 0) throw new Error('The reservation template background could not be loaded.')

  const canvas = document.createElement('canvas')
  canvas.width = TEMPLATE_WIDTH * EXPORT_SCALE
  canvas.height = TEMPLATE_HEIGHT * EXPORT_SCALE
  const context = canvas.getContext('2d')
  if (!context) throw new Error('Could not prepare the reservation PDF canvas.')

  context.scale(EXPORT_SCALE, EXPORT_SCALE)
  context.fillStyle = '#ffffff'
  context.fillRect(0, 0, TEMPLATE_WIDTH, TEMPLATE_HEIGHT)
  context.drawImage(baseImage, 0, 0, TEMPLATE_WIDTH, TEMPLATE_HEIGHT)

  const view = templatePage.ownerDocument.defaultView
  for (const field of templatePage.querySelectorAll<HTMLElement>('.field')) {
    const value = field.innerText.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
    if (!value) continue

    const style = view?.getComputedStyle(field)
    if (!style || style.visibility === 'hidden' || style.display === 'none') continue

    const left = Number.parseFloat(field.style.left)
    const top = Number.parseFloat(field.style.top)
    const width = Number.parseFloat(field.style.width)
    const height = Number.parseFloat(field.style.height)
    const paddingLeft = Number.parseFloat(style.paddingLeft) || 0
    const paddingRight = Number.parseFloat(style.paddingRight) || 0
    const textAlign = style.textAlign
    const x = textAlign === 'center'
      ? left + width / 2
      : textAlign === 'right'
        ? left + width - paddingRight
        : left + paddingLeft

    context.save()
    context.beginPath()
    context.rect(left, top, width, height)
    context.clip()
    context.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
    context.fillStyle = style.color
    context.textAlign = textAlign === 'center' || textAlign === 'right' ? textAlign : 'left'
    context.textBaseline = 'middle'
    context.fillText(value, x, top + height / 2, Math.max(0, width - paddingLeft - paddingRight))
    context.restore()
  }

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true })
  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, PAGE_WIDTH_MM, PAGE_HEIGHT_MM, undefined, 'FAST')
  canvas.width = 0
  canvas.height = 0
  const id = bookingId.trim() || 'confirmation'
  pdf.save(`FlightStay-Reservation-${id}.pdf`)
}